<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="col-12 my-2" [innerHTML]="content"></div>
    </div>
  </div>
</div>
